import { useState } from 'react'
import AdminNavbar from 'components/Navbars/AdminNavbar'
import ItemTabs from 'components/ItemTabs'
import Earnings from './Earnings'
import Sales from './Sales'
import Heatmap from './Heatmap'
import { Container, Title } from './styles'

export default function AdminDashboard () {
  const OPTION_LIST = [
    {label: 'Rendimentos', value: 'earnings', component: <Earnings/>},
    {label: 'Vendas', value: 'sales', component: <Sales/>},
    {label: 'Mapa de calor', value: 'heatmap', component: <Heatmap/>}
  ]

  const [selectedTab, setSelectedTab] = useState (OPTION_LIST[0])

  return (
    <Container>
      <AdminNavbar/>
      <Title>Dashboard</Title>
      <ItemTabs
        tabs={OPTION_LIST}
        selectedTab={selectedTab.value}
        onTabChange={value => setSelectedTab (OPTION_LIST.find (o => o.value === value))}
        tabWidth={180}
      />
      {selectedTab.component}
    </Container>
  )
}
